document.onreadystatechange = function () {
    if (document.readyState !== "complete") {
        document.querySelector("body").style.visibility = "hidden";
        document.querySelector("#skeleton").style.visibility = "visible";
    } else {
        document.querySelector("#skeleton").style.display = "none";
        document.querySelector("body").style.visibility = "visible";
    }
};
$(function () {
    var aside = $('#aside');
    var main = $('#main-content');
    var header = $('#header');

    $('#aside, ' + '.notifications-content, .modal-content').overlayScrollbars({
        scrollbars: {
            autoHide: 'leave',
            touchSupport: true,
        }
    });

    $('#toggleAside').on('click', function () {
        if (aside.hasClass('w-16') && main.hasClass('ml-16')) {
            aside.removeClass('w-16').addClass('w-64');
            main.removeClass('ml-16').addClass('ml-64');
            header.css('width', 'calc(100% - 256px)');
            $(".is-submenu").slideDown('slow');
        } else {
            aside.removeClass('w-64').addClass('w-16');
            main.removeClass('ml-64').addClass('ml-16');
            header.css('width', 'calc(100% - 64px)');
            $(".is-submenu").slideUp('slow');
        }
    });

    aside.mouseover(function () {
        if ($(this).hasClass('w-16')) {
            aside.removeClass('w-16').addClass('w-64 collapsible');
            $(".is-submenu").slideDown('slow');
        }
    });

    aside.mouseleave(function () {
        if ($(this).hasClass('w-64') && $(this).hasClass('collapsible')) {
            aside.removeClass('w-64 collapsible').addClass('w-16');
            $(".is-submenu").slideUp('slow');
        }
    });

    $('.has-submenu').click(function (e) {
        e.preventDefault();
        var submenu = $(this).next('div.is-submenu');
        if (!submenu.is(':visible')) {
            $('div.is-submenu').slideUp('slow');
        }
        submenu.slideToggle('slow');
    });

    $(document).on("submit", "form.form-action", function (e) {
        e.preventDefault();
        var frm = this;
        var buttons = $("button.btn-action", frm);
        var fieldText = $(buttons).data('field-text');
        $(buttons).prop('disabled', true).addClass('is-loading');
        swal.fire({
            title: 'Are you sure?',
            text: fieldText,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#00da66',
            cancelButtonColor: '#e55039',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        }).then((result) => {
            if (result.value) {
                frm.submit();
                $(buttons).prop('disabled', false).removeClass('is-loading');
            } else if (result.dismiss === swal.DismissReason.cancel) {
                $(buttons).prop('disabled', false).removeClass('is-loading');
            }
        });
    });
});

window.processRequest = function (frm, btnSubmit, table) {
    $('.error').hide();
    let form = $(frm);
    let formAction = form.attr('action');
    let formMethod = form.attr('method');
    var formData = new FormData(document.getElementById(frm.attr("id")));
    if(form.find('#files').length) {
        let totalFiles = $('#files')[0].files.length;
        let files = $('#files')[0];
        for (let i = 0; i < totalFiles; i++) {
            formData.append('files' + i, files.files[i]);
        }
        formData.append('totalFiles', totalFiles);
    }
    $.ajax({
        url: formAction,
        data: formData ? formData : form.serialize(),
        dataType: 'JSON',
        type: formMethod,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        beforeSend: function () {
            $(btnSubmit).prop('disabled', true).addClass('is-loading');
        },
        success: function (response) {
            if (response.code === 200) {
                closeAllModals();
                toast.fire({
                    icon: 'success',
                    title: response.message
                });
                if (table) {
                    table.draw(true);
                } else {
                    setTimeout(function () {
                        location.reload();
                    }, 3000);
                }
            }
        },
        error: function (response) {
            $(btnSubmit).prop('disabled', false).removeClass('is-loading');
            if (response.status === 422) {
                toast.fire({
                    icon: 'error',
                    title: 'Invalid request.'
                });
                $.each(response.responseJSON.errors, function (key, value) {
                    $('#' + key + "_error").show().html(value);
                });
            } else {
                closeAllModals();
                toast.fire({
                    icon: 'error',
                    title: 'Oops! Something went wrong, consult system admin.'
                });
            }
        },
        complete: function () {
            $(btnSubmit).prop('disabled', false).removeClass('is-loading');
        }
    });
};

window.closeAllModals = function () {
    $('#modal-add-proceeding, #modal-file-comment, #modal-court, #modal-case-type, #modal-court-type, #modal-case-nature, #modal-summon-type, #modal-law-officer, #modal-add-comment, #modal-send-to-ds').hide();
};

window.getUrlParameter = function getUrlParameter(sParam) {
    var sPageUrl = window.location.search.substring(1), sURLVariables = sPageUrl.split('&'), sParameterName, i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

flatpickr('.flatpickr', {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
});


